<template>
  <SectionPageShell
    section="ads"
    :title="ad?.title || 'Vorschau'"
    :subtitle="ad?.title ? 'Vorschau' : null"
    show-back-link
  >
    <template v-if="userStore.user.isStaffMember()" #header-actions>
      <router-link class="btn btn-outline-primary btn-sm" :to="{name: 'ads.edit', params: {ad_id: $route.params.ad_id}}">
        Bearbeiten
      </router-link>
    </template>
    <div v-if="ad" class="row">
        <div class="col-12">
            <div data-provider="manet_self_promotion"
                 class="ad-container-js mb-3 col-12 col-md-6 mb-4 col-xl-3 col-xxxxl-3"
                 :data-slot-name="`ccp_ad_preview:${ad.id}`">
                <small class="ad-hint">- Anzeige -</small>
                <div class="meat-js d-flex"
                     data-manet-ad="1"
                     data-action="user.click.manet_ad"
                     :data-metadata="adMetadata">
                    <div class="d-flex flex-column w-100 p-3 abl-entry">
                        <img v-if="ad.file_link"
                             class="lozad img-fluid"
                             :alt="ad.title"
                             :src="ad.file_link"
                             :data-src="ad.file_link">
                        <div>
                            <h3 class="my-1 abl-entry-name" :style="titleStyle">
                                {{ ad.title }}
                            </h3>
                            <div v-if="ad.content" v-html="ad.content"></div>
                            <a v-if="ad.link && ad.button_text"
                               target="_blank"
                               rel="noopener noreferrer"
                               :href="ad.link"
                               class="btn center-text btn-kontrast btn-block px-1 mt-2"
                               :style="buttonStyle">
                                {{ ad.button_text }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </SectionPageShell>
</template>

<script>
import SectionPageShell from "@/components/base_type/SectionPageShell.vue";
import {useAdsStore} from "@/stores/ads";
import {useUserStore} from "@/stores/user";

export default {
    name: "AdShow",
    components: {
      SectionPageShell,
    },
    setup() {
        return {
            adStore: useAdsStore(),
            userStore: useUserStore(),
        }
    },
    data() {
        return {
            ad: null,
        }
    },
    created() {
        this.adStore.show(this.$route.params.ad_id).then(({data}) => {
            this.ad = data
        }).finally(() => {
            this.adStore.loading = false
        })
    },
    computed: {
        adMetadata() {
            return JSON.stringify({ad_id: this.ad?.id})
        },
        titleStyle() {
            return this.ad?.custom_color ? {color: this.ad.custom_color} : {}
        },
        buttonStyle() {
            if (!this.ad?.custom_color) {
                return {}
            }
            return {
                backgroundColor: this.ad.custom_color,
                borderColor: this.ad.custom_color,
                color: '#fff',
            }
        },
    },
}
</script>

<style scoped lang="scss">
.ad-container-js {
    max-width: 100%;
}

.ad-hint {
    display: inline-block;
    margin-bottom: 0.5rem;
    color: #6c757d;
}

.abl-entry {
    border: 1px solid #cdcdcd;
    background: #fff;
}

.abl-entry-name {
    font-size: 1.25rem;
}
</style>
